import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react';
import { Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from './AuthContext';
import Cookies from 'js-cookie';
import apiClient from '../api/apiClient';


const UserLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const { isAuthenticated, loading } = useContext(AuthContext);
  const navigate = useNavigate()
  
  // 👇 Redirect if already logged in
  useEffect(() => {
    if (!loading && isAuthenticated) {
      navigate('/admin-login/admin-home', { replace: true });
    }
  }, [isAuthenticated,loading, navigate]);

  if (loading) return null; // Prevents flicker or wrong page render

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await apiClient.post(`/admin/login`, {
        email,
        password,
      },{
        withCredentials: true,
      }
      );

      if(response.status === 200){

        // Handle successful login, e.g., redirect to dashboard
      console.log('Login successful:', response.data.accessToken);

        
        setShowAlert(true)
        setAlertMessage('Login successful');
        // Clear input fields after successful login
      setEmail('');
      setPassword('');
        setTimeout(() => {
          
            window.location.href ='/admin-login/admin-home';
          
          
        }, 3000);
      
      }
      else {
        // Handle unsuccessful login
        setShowAlert(true);
        setAlertMessage('Login failed');
        setTimeout(() => {
          setShowAlert(false);
        }, 3000);
      }
    } catch (error) {
      // Handle login error
      console.error('Login failed:', error);
      setShowAlert(true);
      setAlertMessage('Login failed due to an error');
      
    }
    finally {
      setTimeout(() => {
        setShowAlert(false);
      }, 3000);
    }


  };

  return (
    <>
      <div className="container-fluid d-flex justify-content-center align-items-center vh-100" style={{ backgroundColor: "#343a40" }}>
        <div className="card shadow-lg p-4" style={{ maxWidth: "400px", width: "100%", backgroundColor: "#212529", color: "#fff" }}>
          <div className="card-body">
            <h2 className="text-center fw-bold mb-4" style={{ color: "#ffc107" }}>Admin Login</h2>
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label htmlFor="email" className="form-label fw-bold" style={{ color: "#adb5bd" }}>Authorized Email</label>
                <input
                  type="email"
                  id="email"
                  className="form-control"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  style={{ backgroundColor: "#495057", color: "#fff", border: "none" }}
                />
              </div>
              <div className="mb-3">
                <label htmlFor="password" className="form-label fw-bold" style={{ color: "#adb5bd" }}>Password</label>
                <input
                  type="password"
                  id="password"
                  className="form-control"
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  style={{ backgroundColor: "#495057", color: "#fff", border: "none" }}
                />
              </div>
              <div className="d-grid">
                <button type="submit" className="btn btn-warning btn-block">Login</button>
              </div>
              {showAlert && (
                <div className={`alert mt-3 ${alertMessage === 'Login successful' ? 'alert-success' : 'alert-danger'}`} role="alert">
                  {alertMessage}
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserLogin;
